import { ComboboxOptions, Transition } from "@headlessui/react-v2";
import classNames from "classnames";
import type { ReactNode } from "react";
import { Fragment, forwardRef } from "react";

export interface OptionsProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  onClose?: () => void;
}

export const Options = forwardRef<HTMLUListElement, OptionsProps>(
  ({ onClose, children, className, dataTestId, ...rest }, ref) => (
    <Transition
      as={Fragment}
      enter="transition-opacity ease-in duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-out duration-75"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      afterLeave={onClose}
    >
      <ComboboxOptions
        as="ul"
        modal={false}
        ref={ref}
        className={classNames(
          "border-primary bg-primary absolute mt-1 w-full overflow-hidden rounded-md border shadow-xl focus:outline-none",
          className,
        )}
        data-testid={dataTestId}
        {...rest}
      >
        {children}
      </ComboboxOptions>
    </Transition>
  ),
);

Options.displayName = "Options";
